 import { configureStore } from '@reduxjs/toolkit';
import { AuthenticationSlice } from './AuthenticationSlice';
import { DeleteSchedulePlanSlice } from './DeleteSchedulePlan';
import { PaymentStatusSlice } from './PaymentStatusSlice';
 import { persistReducer, persistStore } from 'redux-persist';
 import { PersistGate } from 'redux-persist/integration/react';
 import storage from 'redux-persist/lib/storage';


const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['CredenceAccountNumber', 'LastName', 'SSN', 'token', 'refreshToken'],
};

const paymentPersistConfig = {
  key: 'paymentStatus',
  storage,
};

const persistedAuthReducer = persistReducer(authPersistConfig, AuthenticationSlice.reducer);
const persistedPaymentReducer = persistReducer(paymentPersistConfig, PaymentStatusSlice.reducer);

export const store = configureStore({
  reducer: {
    Authentication: persistedAuthReducer,
    DeleteSchedulePlan: DeleteSchedulePlanSlice.reducer, 
    PaymentStatus: persistedPaymentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export const persistor = persistStore(store);

// // Persist configuration for authentication slice
// const persistConfig = {
//   key: 'root',
//   storage,
// };

// // Persisted reducer for authentication slice
// const persistedReducer = persistReducer(persistConfig, AuthenticationSlice.reducer);
// const persistedPaymentReducer = persistReducer(persistConfig, PaymentStatusSlice.reducer);


// // Configure the store with both reducers
// export const store = configureStore({
//   reducer: {
//     Authentication: persistedReducer,
//     DeleteSchedulePlan: DeleteSchedulePlanSlice.reducer, 
//     PaymentStatus:persistedPaymentReducer
//   },
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: ['persist/PERSIST'],
//       },
//     }),
// });

// // Persistor for the store
// export const persistor = persistStore(store);


